import type { CustomIconName } from "@repo/ui/components/icon";
import { graphScaleLight } from "@repo/ui/graph-colors";

/**
 * Preset icon colors from the graph color scale
 */
export const ICON_COLORS = [
  "var(--muted-foreground)",
  graphScaleLight[4] ?? "", // red
  graphScaleLight[0] ?? "", // orange
  graphScaleLight[2] ?? "", // yellow
  graphScaleLight[9] ?? "", // greenLight
  graphScaleLight[5] ?? "", // teal
  graphScaleLight[1] ?? "", // blueLight
  graphScaleLight[3] ?? "", // purple
  graphScaleLight[7] ?? "", // pink
] as const;

export const DEFAULT_COLOR = ICON_COLORS[0];
export const DEFAULT_ICON: CustomIconName = "elements";

/**
 * Ordered list of custom icons for the picker grid
 */
export const ORDERED_ICONS: CustomIconName[] = [
  "elements",
  // Communication and Messaging
  "inbox",
  "email",
  "layers",
  "bell",
  "megaphone",
  "volume-high",
  "headphones",
  "mic",
  "musicnote",
  "key",
  "lock-2",
  "comment",
  "comment-dots",
  "comments",
  "comment-text",
  "note-text",
  "alert-circle",
  "alert-triangle",
  "check-circle",
  "plus-square",
  "cross-circle",
  "procent-circle",
  "question",
  "cut",
  "search",
  "filter-2",
  "archive",
  "trash",
  // User Interface and Navigation
  "battery-1",
  "battery-2",
  "battery-3",
  "target",
  "globe",
  "mapview",
  "compass",
  "pin",
  "direction",
  "dashboard",
  "verified",
  "user",
  "users",
  "user-square",
  "emotion-happy",
  "emotion-neutral",
  "emotion-sad",
  "emotion-smile",
  "emotion-wow",
  "thumbsup",
  "thumbsdown",
  "progress",
  "watch",
  "time",
  "timer",
  "calendar-event",
  "calendar-number",
  // Electronics and Technology
  "folder",
  "folder-open",
  "activity",
  "phone",
  "tv",
  "monitor",
  "laptop",
  "devices",
  "printer",
  "link-2",
  "internet",
  "broadcast",
  "wifi",
  "bluetooth",
  "keyboard",
  "processor",
  "terminal",
  "harddrive",
  "server",
  "server-2",
  "plug",
  // Nature and Environment
  "sun",
  "moon",
  "cloud",
  "star",
  "lightning",
  "fire",
  "bug",
  "thermometer",
  // Business and Finance
  "chart-bar",
  "chart-column",
  "chart-line",
  "presentation-chart",
  "presentation-line",
  "dollar-circle",
  "euro-circle",
  "invoice",
  "receipt",
  "shoppingbag",
  "shoppingcart",
  "creditcard",
  "wallet",
  "briefcase",
  "book",
  "bookmark",
  "tag",
  "ticket",
  // Objects and Items
  "bulb",
  "atom",
  "rocket",
  "trophy",
  "award",
  "home",
  "babycarriage",
  "bed",
  "bed-2",
  "box",
  "box-2",
  "gift",
  "play",
  "videocamera",
  "filmtape",
  "camera",
  "image-2",
  "image-3",
  "brush",
  "flag",
  "dumbell",
  "weighter",
  "ruler",
  "gear",
  "nut",
  "wrench",
  "heart",
  "eye",
  "glasses",
  "glasses-vr",
  "cutlery-2",
  "coffee",
  "glass-wine",
  "glass-cocktail",
  "truck",
  "building",
  "anchor",
  "lifebuoy",
  "umbrella",
  "wheelchair",
  "yinyang",
];

export const EMOJI_BLACKLIST = ["relaxed", "white_frowning_face"];
